// this file is generated by update_shopify_store_data.py at 2026-11-03 20:11:33.576038
var courses = [
    {
        "course_id": "A6228A9B-6D8B-F111-99B2-005056A7F5E9",
        "course_version": 1,
        "name": "AAENP -  Essential Concepts for Emergency Nurse Practitioners Program",
        "course_type": 32,
        "author_information": "",
        "description": "Essential Concepts for Emergency Nurse Practitioners is AAENP's comprehensive online education program, developed to close the knowledge gaps that emergency and urgent care providers encounter most. Every course is created and delivered by practicing experts in emergency care, so you learn directly and efficiently from the clinicians who do this work. The program spans six topic-focused areas \u2014 from high-acuity clinical presentations and hands-on procedures to pharmacology, obstetric and pediatric emergencies, and the professional practice instruction that empowers nurse practitioners to optimize their scope and their careers. Learn on your schedule, earn AAENP-provided CE contact hours, and build the breadth of knowledge the emergency setting demands.",
        "learning_objectives_html": "At the conclusion, participants should be able to:",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Medicine",
                "is_system_course_category": null
            },
            {
                "course_category_id": "00DB13BE-CF89-F111-99B9-005056A7EBB6",
                "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Curriculum",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": [
            {
                "course_id": "04B58173-DE17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Pediatric Behavioral Health Emergencies",
                "course_type": 1,
                "author_information": "Kathleen Jordan, DNP, RN, FNP-BC, ENP-C, SANE-P, FAEN, FAANP",
                "description": "The focus of this presentation is to provide evidence-based information for clinical decision-making through a discussion of trauma informed strategies to conduct a patient centered interview.\r\n\r\nEmergency department visits for behavioral health problems in children and adolescents continues to escalate, with a dramatic increase over the past decade. The ED has been classified as a safety net for this patient population, however this places a huge burden on ED processes and throughput. This situation is complicated by limitations in the ED that effect the timely and comprehensive patient evaluation, and the shortage of available inpatient beds and outpatient services for those children and adolescents who need mental health care.\r\n\r\nIt is imperative that emergency care providers have the knowledge and skill set to provide high quality, safe and effective care for this ED population. The focus of this presentation is to provide evidence-based information for clinical decision-making through a discussion of trauma informed strategies to conduct a patient centered interview, including essential collateral information and ancillary studies. Discussion will also include differentiating a medical versus psychiatric emergency in children and adolescents. The presentation will conclude with a discussion of the most common pediatric behavioral health problems encountered in the ED.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Discuss the impact of pediatric behavioral health emergencies on ED processes and throughput.</li>\r\n    <li>Identify goals of care for quality and safety for the pediatric patient with a behavioral health emergency in the ED.</li>\r\n    <li>Differentiate medical versus psychiatric disorders in pediatric patients in the ED.</li>\r\n    <li>Describe the emergency management of patients with the following behavioral health emergencies: aggression and violence; autism spectrum disorder, serotonin syndrome and complications related to COVID19.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "8C2AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5936B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Behavioral Health Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9106255A-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Pediatric - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E5A9019D-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "55471635-DF17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Basic Suturing: Foundational Skills for APPs",
                "course_type": 1,
                "author_information": "Jolene Dodd, MSN, APRN, FNP-C, AGACNP-BC, ENP-C",
                "description": "This course focuses on the evaluation and management of lacerations, emphasizing accurate wound assessment and identification of characteristics that influence closure decisions, including situations where primary repair should be avoided. Learners will practice simple interrupted and running sutures, review proper irrigation and wound cleansing techniques to reduce infection risk, and apply best practices in documentation, discharge instructions, follow-up care, and medicolegal considerations.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Accurately assess and describe lacerations</li>\r\n    <li> Identify key wound characteristics that guide closure decisions and when to avoid primary repair</li>\r\n    <li>Demonstrate correct techniques for simple interrupted and running sutures</li>\r\n    <li>Recognize proper irrigation methods and wound cleansing practices to reduce infection risk</li>\r\n    <li>Apply best practices in documentation, follow-up instructions, and medicolegal considerations</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF3008FA-83E5-E511-8C5E-005056B12B9C",
                        "course_category_name": "Wound Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Procedures",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.2,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "92156A87-DF17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Ischemic Arm Block for Closed Wrist Fracture",
                "course_type": 1,
                "author_information": "Shawn Schoppe, DNP, APRN, FNP-C, ENP-C, LP",
                "description": "This presentation will describe the Bier\u2019s Block, along with its contraindications. Best practices will be highlighted as well as benefits and effectiveness.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe indications and contraindications for Bier&rsquo;s Block</li>\r\n    <li>Describe procedure for Bier&rsquo;s Block</li>\r\n    <li>Describe benefits to using a Bier&rsquo;s Block</li>\r\n    <li>Credit Designations</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Procedures",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9C04975-413C-11DD-9765-001517135727",
                        "course_category_name": "Orthopedic Disorders",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6C3323AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Pain Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "525EA248-E017-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Bugs & Drugs: An Antibiotic Update",
                "course_type": 1,
                "author_information": "Michael Gooch, DNP, APRN, CCP, ACNP-BC, FNP-BC, ENP-C",
                "description": "This presentation will provide a review and update on empiric \"bugs and drugs\" commonly encountered in emergency care settings. A brief review of microbiology and the classes of medications and their common side effects and interactions will be reviewed. Using a body system approach, the current recommendations for appropriate empiric agents will be reviewed including ENT, CAP, SSSTI, STI, UTI, viral infections, exposure prophylaxis, and systemic problems such as sepsis. Lastly, the importance of patient education and antibiotic stewardship will be addressed.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Identify the mechanism of actions of the five main categories of antibiotic therapies.</li>\r\n    <li>Describe common adverse drug reactions associated with antimicrobial agents.</li>\r\n    <li>Modify the plan of care to incorporate the appropriate empiric agent based on the presumed site or source of infection.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "9B623ACF-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7B66D488-1B26-E711-9EDE-005056B14F90",
                        "course_category_name": "Antimicrobials",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "415C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5E38CE86-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Pharmacology - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "788C2C5C-E017-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Taming the Toxins: Solutions for Ingestions and Exposures",
                "course_type": 1,
                "author_information": "Michael Gooch, DNP, APRN, CCP, ACNP-BC, FNP-BC, ENP-C",
                "description": "Emergency nurse practitioners often manage patients with a variety of exposures and ingestions. These can be accidental or intentional overdoses, resulting in challenging and sometimes unique treatment plans. During this presentation, the typical toxidromes as well as a range of toxins, medications, and substances will be discussed. Newer agents of abuse such as xylazine and new strategies including high dose insulin and intralipid therapy administration will be reviewed.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Identify applicable reversal agents in select toxic ingestions and exposures.</li>\r\n    <li>Recall indications for high dose insulin and intralipid therapy in select toxic emergencies.</li>\r\n    <li>Discuss appropriate ordering, monitoring, and risk assessment associated with reversal agents.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "B1D5F710-EFD0-E511-AEA0-005056B11FFF",
                        "course_category_name": "Gastrointestinal Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "71623ACF-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - OB Emergencies Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5E38CE86-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Pharmacology - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "415C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B623ACF-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "509FB375-E017-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Pharmacologic Treatment of Crotalid Snakebites",
                "course_type": 1,
                "author_information": "Gordon Worley, MSN, RN, FNP-C, ENP-C, FAWM",
                "description": "This course will examine characteristics of venomous snake bites. Prehospital and ED evaluation and care will be discussed as well as utilization of antivenom.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Recognize and describe the identifying characteristics of venomous snakes native to North America.</li>\r\n    <li>   Describe prehospital and emergency department evaluation and treatment of crotalid snakebite.</li>\r\n    <li>   Discuss antivenom treatment of crotalid envenomation. (Pharm content ~ 0.3 hours)</li>\r\n    <li>   Identify common misconceptions about snake behavior and snakebite treatment.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "415C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "02064EC2-15DD-E311-AD18-005056B141CC",
                        "course_category_name": "Medications",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B623ACF-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5E38CE86-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Pharmacology - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "512CB365-6DC3-E911-814D-005056B14D10",
                        "course_category_name": "Injuries",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.8,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "D08B328A-E017-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Empowering Nurse Practitioners in Policy and Innovation",
                "course_type": 1,
                "author_information": "Cindy Weston, DNP, APRN, FNP-BC, FAANP, FAAN",
                "description": "This presentation is designed to inspire and equip nurse practitioners (NPs) to take an active role in shaping health policy and driving innovative solutions to improve patient outcomes. Participants will explore the evolving role of NPs in health policy at local, state, and national levels, and examine real-world examples of impactful innovations led by NPs. The course emphasizes practical strategies for becoming involved in policy work, advocating for greater access to care, and influencing change to promote equity and improve healthcare delivery across diverse populations.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe the Nurse Practitioners role in health policy</li>\r\n    <li>Outline innovations for NPs influencing health policy</li>\r\n    <li>Engage in health policy activities to improve access and outcomes</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C01FDB4F-F53E-E711-B09D-005056B10493",
                        "course_category_name": "Leadership & Workforce Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4C5C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D4B948D5-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "05EA179B-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Professional Practice - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "E4A93AB7-E017-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Mitigating Malpractice Risks in the ED: Strategies for the ENP",
                "course_type": 1,
                "author_information": "David Warren, DNP, CRNA, FNP, ACNP, ENP",
                "description": "This session will focus on practical strategies and best practices for Emergency Nurse Practitioners to minimize malpractice risks in the Emergency Department (ED). Attendees will explore the concept of \u201cstandard of care\u201d, the anatomy of a malpractice claim, common sources of malpractice claims, learn risk management techniques, and understand the importance of thorough documentation and communication. The session will include case studies, legal insights, and interactive discussions to equip Nurse Practitioners with the tools needed to reduce liability and enhance patient safety. By the end of the presentation, participants will be able to apply these strategies in their daily practice, fostering a safer and legally sound clinical environment.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Understand Legal Standards of Care and the anatomy of a malpractice claim: Explain the legal standards of care applicable to Nurse Practitioners in the Emergency Department and how adherence to these standards can prevent malpractice claims.</li>\r\n    <li>Identify common malpractice risks: Recognize and understand the common sources of malpractice claims in the ED.</li>\r\n    <li>Implement risk management strategies: Apply effective risk management techniques, including thorough documentation and clear communication, to minimize liability in emergency care.</li>\r\n    <li>Develop effective communication skills: Strengthen communication skills with patients, families, and interdisciplinary teams to improve patient outcomes and reduce misunderstandings that can result in legal action.</li>\r\n    <li>Implement proactive patient education: Design and implement patient education strategies that inform patients about their care plans, potential risks, and follow-up instructions, thereby reducing the risk of dissatisfaction and potential malpractice claims.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "05EA179B-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Professional Practice - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D4B948D5-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4C5C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "84586E86-BF29-11DE-88D6-0015171C1B93",
                        "course_category_name": "Legal & Corporate Compliance",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1EA354BE-D2C9-E511-82AF-005056B150D3",
                        "course_category_name": "Regulatory Agencies",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FEC6E955-D5C9-E511-82AF-005056B150D3",
                        "course_category_name": "Risk Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "971E14AF-67DA-E511-9165-005056B141CC",
                        "course_category_name": "Ethical Practice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "D1542803-DF17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Advancing Pain Management in Emergency Medicine: Innovative Approaches to Regional Anesthesia",
                "course_type": 1,
                "author_information": "David Warren, DNP, CRNA, FNP, ACNP, ENP",
                "description": "This session explores innovative regional anesthesia techniques for acute and chronic pain in the ED. NPs will learn indications, pharmacology, and ultrasound-guided approaches through case studies to enhance pain control and patient outcomes.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Explore basic and advanced regional anesthesia techniques: Learn about the latest advancements in regional anesthesia, including ultrasound-guided nerve blocks, local anesthetic pharmacology, and their applications in the ED setting.</li>\r\n    <li>Implement innovative pain management strategies: Develop the ability to apply new techniques and tools for regional anesthesia to improve pain management and patient outcomes in the emergency department.</li>\r\n    <li>Optimize efficiency and safety: Analyze how advanced regional anesthesia techniques can reduce the need for systemic opioids and enhance overall efficiency and safety in patient care in the emergency department. Discuss local anesthetic systemic toxicity (LAST) and it&rsquo;s treatment.</li>\r\n    <li>Address and mitigate contraindications to regional anesthesia: Identify and address specific contraindications to regional anesthesia.</li>\r\n    <li>Specific regional anesthetic blocks: Utilize evidence-based approaches to compare and contrast different regional anesthetic techniques that can be utilized in emergency medicine, including upper extremity blocks, lower extremity blocks, and truncal blocks</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6C3323AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Pain Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Procedures",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "31887D19-DF17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Basic EKG Interpretation for the ENP",
                "course_type": 1,
                "author_information": "Jolene Traum, ENP-C",
                "description": "This course focuses on basic anatomy, electrical pathways, components of the 12 lead EKG, and EKG patterns. This course will go over recognition of EKG patterns, causes, and meanings.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe the electrical pathway of the heart</li>\r\n    <li>Describe the components of a normal 12 lead EKG</li>\r\n    <li>Relate components of EKG to cardiac anatomy</li>\r\n    <li>Recognize patterns, meanings, and potential causes of EKGs</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6133B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiac Disorders",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Procedures",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.8,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "BEAAF648-DF17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Treating Dental Pain in the Emergency Department",
                "course_type": 1,
                "author_information": "Erica May, DNP, APRN, FNP-BC, AGACNP-BC, ENP-C",
                "description": "This course addresses the evaluation and management of acute, non-traumatic dental pain in the emergency department. Learners will review criteria for identifying dental pain presentations, apply evidence-based pharmacologic guidelines for pain control, and discuss the indications and techniques for supraperiosteal, mental, and inferior alveolar dental nerve blocks.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Recognize patients with acute non-traumatic dental pain the  ED</li>\r\n    <li>Apply a published guideline for the pharmacological management of dental pain in the ED</li>\r\n    <li>Discuss supraperiosteal, mental, and inferior alveolar dental nerve blocks</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6529FF26-21FE-E611-A7FF-005056B16BE3",
                        "course_category_name": "Mouth Disorders",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "99E6968A-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Dental Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Procedures",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "05B788BA-DF17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Point-of-Care Ultrasound in High-Altitude Sickness (HAI): A Lifesaving Tool in Extreme Environments",
                "course_type": 1,
                "author_information": "Ari Chaskes, DNP, FNP-BC, ENP-C, NRAEMT",
                "description": "This presentation will begin with a refresher on HAI followed by an explanation of using POCUS to diagnose and monitor in these environments. Practical considerations and challenges will be discussed.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe key clinical features of high-altitude illness, including acute mountain sickness (AMS), high-altitude pulmonary edema (HAPE), and high-altitude cerebral edema (HACE).</li>\r\n    <li>Explain the principles and advantages of point-of-care ultrasound (POCUS) as a diagnostic and monitoring tool in remote, high-altitude environments.</li>\r\n    <li>Identify specific POCUS applications relevant to high-altitude illness, such as:\r\n    <ul>\r\n        <li>a.  Pulmonary assessment for B-lines in HAPE</li>\r\n        <li>b.  Cardiac evaluation for right heart strain</li>\r\n        <li>c.  Optic nerve sheath diameter (ONSD) measurement for HACE.</li>\r\n    </ul>\r\n    </li>\r\n    <li>Discuss the practical considerations, challenges, and limitations of using POCUS in austere, high-altitude settings.</li>\r\n    <li>Recognize future directions and opportunities for research and technology development that can expand POCUS use in wilderness and expedition medicine.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "437DEC7D-A8BA-E811-9AF1-005056B1456A",
                        "course_category_name": "Medical Imaging",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "833E5FD4-DF17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Radiology Essentials: Interpretation of Common and Can't Miss Imaging",
                "course_type": 1,
                "author_information": "Stephen Jameson, MD, FACEP",
                "description": "Interpretation of radiographic imaging is a skill every emergency provider needs to possess. In this session you will review a multitude of common and can't miss radiographic studies and the clinical context within which they were obtained. This is true experiential learning as you see true life cases and their associated images. It's a can't miss presentation.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe radiographic findings on standard imaging</li>\r\n    <li>For better communication between colleagues</li>\r\n    <li>For improved clarity of diagnosis &amp; billing</li>\r\n    <li>Interpret radiographic studies of many common conditions</li>\r\n    <li>State how the appropriate use of imaging can help diagnose several can&rsquo;t miss diagnoses</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "437DEC7D-A8BA-E811-9AF1-005056B1456A",
                        "course_category_name": "Medical Imaging",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "92188200-E017-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Recognizing and Management of Incarcerated Gravid Uterus in the ED: An Update for Treatment",
                "course_type": 1,
                "author_information": "Dr. Jill Ogg-Gress, DNP, APRN, FNP-c ENP-c",
                "description": "This presentation aims to recognize and manage patients with symptoms suggestive of incarcerated gravid uterus (IGU) who present to the emergency department. It will outline strategies for identifying patients with complaints consistent with IGU, describe complications/risks, provide diagnostic recommendations, and discuss recently published new treatment strategies with minimally invasive ultrasound techniques for management. Case studies will also be provided during the presentation.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe common patient complaints consistent with incarcerated gravid uterus</li>\r\n    <li>Identify complications, risks, and diagnostics for incarcerated gravid uterus</li>\r\n    <li>Discuss modalities for treatment of incarcerated gravid uterus including new treatment strategies</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "975A148E-A6FF-E611-A64B-005056B1522B",
                        "course_category_name": "Obstetric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Procedures",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "71623ACF-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - OB Emergencies Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7A1F6972-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - OB Emergencies - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A3767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - OB Emergencies Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "154F411A-E017-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Code Red: Managing OB Hemorrhage following Spontaneous Abortion in the ED",
                "course_type": 1,
                "author_information": "Amanda Hitt, DNP, ENP-C, FNP-C",
                "description": "This course will examine common causes of hemorrhage in pregnancy and current guidelines for treatment.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Discuss current treatment guidelines for selected OB emergencies during first trimester. </li>\r\n    <li>Discuss current treatment guidelines for selected OB emergencies during the second trimester.</li>\r\n    <li>Verbalize pathophysiology of common causes of hemorrhage following spontaneous abortion.</li>\r\n    <li>Identify pharmacological treatments and surgical options for hemorrhage following spontaneous abortion in the first trimester.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "7A1F6972-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - OB Emergencies - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "71623ACF-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - OB Emergencies Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "975A148E-A6FF-E611-A64B-005056B1522B",
                        "course_category_name": "Obstetric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A3767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - OB Emergencies Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "0A68089E-E017-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Imposter Syndrome and the Role of the ED Nurse Practitioner",
                "course_type": 1,
                "author_information": "Kathleen Ahn, DNP, FNP-BC",
                "description": "Nurse Practitioners employed in Emergency Medicine within an academic system have daily interactions with multiple specialty services. From Trauma Surgery to neurology, Ophthalmology to Rheumatology, Interventional Radiology to Colorectal Surgery, Hematology-Oncology and more, the breadth of academic medicine is represented within the system. ED NPs must be prepared to advocate for their patients by identifying a need for consult, formulating an appropriate consultation question, ordering preliminary lab or radiology testing in preparation for a potential consult, and then mastering an effective presentation to the consulting team so that a clinical need or question can be addressed. A case presentation to a specialist must be clear, concise, and tie together all pertinent information. The initial presentation to a consulting team can either forward the case expediently, or create a potential delay in care. When imposter syndrome affects NP practice, these interactions can be challenging.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li> Name 7 skills the NP practicing in the Emergency Department of an Academic Medical Center must develop to facilitate meaningful interactions with a breath of specialty services.</li>\r\n    <li>Discuss at least 5 elements of an effective case presentation to a specialty service within academic medicine.</li>\r\n    <li>What are 3 common feelings of a professional who faces the challenges of Imposter syndrome</li>\r\n    <li>Detail 5 affirmations and/or effective interventions for an NP who is addressing imposter syndrome, or feelings of anxiety and intellectual self-doubt, within the work environment</li>\r\n    <li>Discuss a challenging case presentation you experienced that either succeeded, or did not succeed. Discuss any feelings of intellectual self doubt that may have influenced your clinical discussion, and your opinion of any effect on patient outcome.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D4B948D5-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4C5C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "222C7486-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Interpersonal Relationships",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C01FDB4F-F53E-E711-B09D-005056B10493",
                        "course_category_name": "Leadership & Workforce Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Personal Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "05EA179B-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Professional Practice - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "0F66D1CA-E017-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Hard Truths, Soft Landings: Delivering Bad News with Compassion",
                "course_type": 1,
                "author_information": "Rachel Helms, DNP, APRN, AGACNP-BC, FNP-BC, ENP-C",
                "description": "Emergency department providers frequently face the difficult responsibility of delivering bad news to patients and their families. Although this is always a challenging task, the fast-paced and high-pressure environment of the ED adds unique complexities that can intensify the difficulty. This presentation will equip providers with a thoughtful, compassionate approach to handling these tough conversations.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li> Identify the unique challenges of delivering bad news in the emergency department.</li>\r\n    <li>Understand the importance of an intentional approach to delivering bad news.</li>\r\n    <li>Apply key communication techniques to deliver bad news in a compassionate and clear manner.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "05EA179B-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Professional Practice - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D4B948D5-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4C5C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0E34B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Patient Rights",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3B66D963-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Quality Assurance and Performance Improvement",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "551FF8E5-E017-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Screening for IPV in the ED",
                "course_type": 1,
                "author_information": "Amanda Hitt, DNP, ENP-C, FNP-C and\r\nHilary Ashton Glover, DNP, FNP-C, ENP-C, SANE-A",
                "description": "This webinar will increase awareness of Intimate Partner Violence impact, warning signs and resources",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Identify prevalence of IPV</li>\r\n    <li>Identify 3 risk factors for IPV</li>\r\n    <li>Identify 3 signs &amp; symptoms of IPV</li>\r\n    <li>Describe the screening guidelines for IPV</li>\r\n    <li>Identify 2 interviewing techniques for IPV</li>\r\n    <li>Identify 2 legal considerations related to IPV</li>\r\n    <li>Discuss the mental health impact of IPV</li>\r\n    <li>Identify 1 barrier and 1 solution related to IPV</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4C5C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57DADFC8-E203-E911-A43F-005056B13721",
                        "course_category_name": "Sexual Abuse & Assault",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "51FB57AE-C98C-EB11-80DF-005056B134EC",
                        "course_category_name": "Intimate Partner Violence",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "05EA179B-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Professional Practice - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB3023AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Knowledge Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C01FDB4F-F53E-E711-B09D-005056B10493",
                        "course_category_name": "Leadership & Workforce Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D4B948D5-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "4BFCE9F3-E017-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Social Determinants of Health for the ED Provider",
                "course_type": 1,
                "author_information": "Travis McCall, PhD, APRN, CCP",
                "description": "Social determinants of health are non-medical factors that influence the health of individuals, communities, and populations. The Centers for Medicare and Medicaid Services (CMS) has prioritized the need to promote health equity, expand coverage, and improve overall health among patients who benefit from CMS programs. As emergency departments provide access to care for many patients who may be affected by social determinants of health, ENPs are positioned to improve health equity and patient outcomes in the provision of care. This lecture will describe social determinants of health, identify factors that may affect patient health, and discuss the implications of such factors when managing and dispositioning patients in the emergency department.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe the influence of social determinants of health outcomes for individuals, communities, and populations.</li>\r\n    <li>Identify factors affecting the health of individuals, communities, and populations within the context of the emergency department.</li>\r\n    <li>Discuss the implications of social determinants of health in the management and disposition of patients in the emergency department.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4C5C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "05EA179B-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Professional Practice - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F29F524D-D7C9-E511-82AF-005056B150D3",
                        "course_category_name": "Patient Engagement",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D4B948D5-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "20607355-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Patient Needs",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "4F12A4B3-DE17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Pediatric Toxicological Emergencies: I only turned my back for one second!",
                "course_type": 1,
                "author_information": "Michael Schill III, DNP, FNP-BC, ENP-C, CEN, CFRN, MICN",
                "description": "Each day, we are unaware of some dangers around the house. It only takes a moment for a pediatric patient to get into something potentially harmful. We have all heard the phrase from a parent: \"I only turned my back for one second.\" This presentation will provide a review of the most common harmful household items and common medications. Whether you work in the Emergency Department or Urgent Care, this will help to review common signs and symptoms and up-to-date treatment. This interactive case scenario-based presentation will review and discuss pharmacological and non-pharmacological treatment modalities.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Discuss the epidemiology of household ingestions in the pediatric population</li>\r\n    <li>Describe evaluation and management of potentially fatal ingestion of a single prescription medication</li>\r\n    <li>Identify common non-toxic toys that can still be toxic to the pediatric population</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E5A9019D-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8C2AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B623ACF-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "415C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5E38CE86-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Pharmacology - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9106255A-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Pediatric - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "F36CA5E2-DE17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Advanced Suturing: EM Advanced Suturing Techniques",
                "course_type": 1,
                "author_information": "Jolene Dodd, MSN, APRN, FNP-C, AGACNP-BC, ENP-C",
                "description": "This course provides hands-on instruction in advanced suturing and wound repair techniques. Learners will practice horizontal and vertical mattress sutures, corner stitches, buried sutures, and the palming technique to improve precision and control. Emphasis is placed on cosmetic and high-tension wound management, including vermillion border, nailbed, and finger injuries, with instruction in digital nerve blocks and nail plate stabilization.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Perform advanced suturing techniques including horizontal mattress, vertical mattress, corner stitch, and buried sutures.</li>\r\n    <li>Apply effective strategies for cosmetic and high-tension wound repairs including vermillion border and nailbed lacerations.</li>\r\n    <li>  Execute the palming technique to enhance dexterity and control during suturing.</li>\r\n    <li> Demonstrate knowledge of finger and hand injury repair including digital nerve blocks and nail plate stabilization.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF3008FA-83E5-E511-8C5E-005056B12B9C",
                        "course_category_name": "Wound Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Procedures",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "F60F215D-DF17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Don't CRASH Your Patient! Mitigating the Physiologically Difficult Airway",
                "course_type": 1,
                "author_information": "Jacob Miller, DNP, MBA, ACNP, ENP-C, CNS, NRP",
                "description": "Nearly all airway courses focus on the physical task of intubation. Similarly, most \"difficult airway\" courses cover psychomotor and procedural challenges encountered in airway management. Here, we focus on the physiologic difficulties that can lead to clinical deterioration during the peri-intubation period and how to mitigate them. Next time you have to perform airway management, don't allow your patient to CRASH -- make sure their physiology has been optimized first!",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Differentiate anatomic from physiologic airway management difficulties</li>\r\n    <li>Identify risk factors predicting physiologic difficulty using the CRASH and HOp mnemonics</li>\r\n    <li>Formulate a treatment plan to prevent peri-intubation arrest in the physiologically challenging patient</li>\r\n    <li>Compare and contrast airway management strategies in the medical versus trauma patient</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFFFFFFF-FFFF-FFFF-FFFF-000000001090",
                        "course_category_name": "Airway Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "55C0CA34-E017-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Addiction & Treatment in the ED",
                "course_type": 1,
                "author_information": "K. Chenin Kenig, RN, MSN, FNP-C",
                "description": "This presentation will describe the role of the hospital emergency department (ED), not simply in emergency treatment of overdose, but as a provider of care for underlying addiction and as a catalyst for change in our approach to drug use as a society.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Understand the Pharmacokinetics of buprenorphine</li>\r\n    <li>Understand Initial dosing, induction of buprenorphine in the ED</li>\r\n    <li>Understand that you can bill for MAT in the ED, G2213</li>\r\n    <li>Be able to understand ways to obtain X-waiver</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5E38CE86-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Pharmacology - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "415C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "02064EC2-15DD-E311-AD18-005056B141CC",
                        "course_category_name": "Medications",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B623ACF-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1EE81567-9882-E211-B22E-0015171C1A75",
                        "course_category_name": "Substance Abuse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.9,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "0E54130C-E117-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Venous Thromboembolism: Initiation of Pulmonary Embolism Response Teams (PERT)",
                "course_type": 1,
                "author_information": "Speaker: Jolene Donald, AG-ACNP, ENP, FNP, MSN, RN",
                "description": "This course will dive into the pathophysiology, risk stratification, and work-up of patients related to PE and DVT. PERT teams will be discussed including the benefits to both the patient and the hospital.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Identify 3 signs and symptoms of PE and DVT</li>\r\n    <li>Identify diagnostic studies for both PE and DVT</li>\r\n    <li>Identify and utilize 3 risk stratification tools to assist in identification of patient at higher risk for PE who require further work-up</li>\r\n    <li>Name 5 reasons PERTs benefit patients and the hospital</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D4B948D5-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4C5C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "05EA179B-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Professional Practice - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4FDB4F21-6F00-E711-9B94-005056B141CC",
                        "course_category_name": "Process Improvement",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.6,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "4D1A9C4B-DE17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Measles: A Rash from the Past",
                "course_type": 1,
                "author_information": "Michael Gooch, DNP, APRN, CCP, ACNP-BC, FNP-BC, ENP-C",
                "description": "The course will examine the current Measles outbreak and implications for Emergency and Urgent Care Providers.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Examine Measles epidemiology and pathophysiology.</li>\r\n    <li>Discuss Measles diagnostics and plan of care pearls.</li>\r\n    <li>Identify complications associated with Measles.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8C2AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6F560093-37E7-11DD-B494-001517135513",
                        "course_category_name": "Infectious Diseases",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9106255A-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Pediatric - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E5A9019D-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.6,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "EEE7809D-DE17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Pediatric Lyme Disease",
                "course_type": 1,
                "author_information": "Teresa Dodge, DNP, FNP-C, CEN",
                "description": "Lyme disease is prevalent in the United States, especially in the Northeast. In fact, cases are only increasing and spreading further south. Pediatric patients, specifically those between the ages of five and fourteen, have the highest incidence of infection. Diagnosing and treating Lyme disease in pediatric patients can also be tricky, even for the most experienced nurse practitioners - the classic Lyme rash isn\u2019t always a bullseye, and pediatric Lyme arthritis can mimic many other acute pediatric orthopedic diseases. To make things worse, in 2020, while we were all distracted by COVID, the Infectious Diseases Society of America (IDSA), the American Academy of Neurology (AAN), and the American College of Rheumatology (ACR) released an updated guideline for the management of Lyme disease. These updated guidelines significantly changed the treatment of some Lyme patients. This presentation will review Lyme disease in the pediatric population, its signs and symptoms, how to diagnose it, and how to treat it.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>At the conclusion of this presentation, attendees should be able to define Lyme disease.</li>\r\n    <li>At the conclusion of this presentation, attendees should be able to summarize the best testing and screening for Lyme in pediatric patients.</li>\r\n    <li>At the conclusion of this presentation, attendees should be able to summarize the pediatric treatment for Lyme disease and when to initiate prophylaxis.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6F560093-37E7-11DD-B494-001517135513",
                        "course_category_name": "Infectious Diseases",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8C2AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E5A9019D-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9106255A-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Pediatric - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "B2E077CD-DE17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Single Dose Killers: Pediatric Toxicology",
                "course_type": 1,
                "author_information": "Micheal Gooch, DNP, APRN, ACNP-BC, FNP-BC, FAANP, FAEN",
                "description": "Toxicological emergencies are commonly encountered in emergency care. Some are more serious than others. In pediatric patients, there are a few substance known as the single dose killers as it only takes a small amount to cause toxicity. This presentation will review these agents, discuss their clinical manifestations, and management priorities to allow emergency NPs to manage these patients more competently.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Identify some of the single dose killers in pediatric toxicology</li>\r\n    <li>Modify management plans to correct toxicities encountered in pediatric toxicology</li>\r\n    <li>Introduce mechanisms for alleviating secondary traumatic stress, compassion fatigue, and burnout among professionals who provide care to critically ill or injured patients.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "512CB365-6DC3-E911-814D-005056B14D10",
                        "course_category_name": "Injuries",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B623ACF-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "415C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8C2AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5E38CE86-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Pharmacology - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E5A9019D-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9106255A-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Pediatric - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "70D08E73-DF17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Clinical Integration of POCUS for Musculoskeletal Complaints in the ED",
                "course_type": 1,
                "author_information": "Kelly Craven, DNP, ENP, FNP, NRP",
                "description": "This course will examine the use of ultrasound to assist in the diagnosis and management of various musculoskeletal injuries in the ED.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>\r\n    Identify appropriate use of point of care ultrasound (POCUS)\r\n    </li>\r\n    <li>Describe the mechanics of ultrasound\r\n    </li>\r\n    <li>Describe the evaluation of shoulder anatomy using POCUS\r\n    </li>\r\n    <li>Identify common imaging findings associated with shoulder dislocation </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "437DEC7D-A8BA-E811-9AF1-005056B1456A",
                        "course_category_name": "Medical Imaging",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.6,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "C6C823A0-DF17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Nail Procedures for ED & Urgent Care Providers",
                "course_type": 1,
                "author_information": "Amanda Hitt, DNP, FNP-C, ENP-C",
                "description": "This course will take the viewer through common nail procedures that present to EDs and urgent care centers. The course will discuss the procedures, including digital blocks, preparation considerations, contraindications, and more.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Identify nail procedures commonly performed in the ED and Urgent Care settings.</li>\r\n    <li>Discuss methods for placing a digital block.</li>\r\n    <li>Understand indications and management of various nail procedures.</li>\r\n    <li>Identify important considerations for practice, including scope, consultations, and referrals.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "512CB365-6DC3-E911-814D-005056B14D10",
                        "course_category_name": "Injuries",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Procedures",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF3008FA-83E5-E511-8C5E-005056B12B9C",
                        "course_category_name": "Wound Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.2,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "800304EE-DF17-F111-99AB-005056A70840",
                "course_version": 2,
                "name": "To See or Not to See: Eye Trauma",
                "course_type": 1,
                "author_information": "Karen O\u2019Connell Schill, DNP, FNP-BC, ENP-C, CEN, CFRN, NREMT & Michael Schill III, DNP, FNP-BC, ENP-C, CEN, CFRN, MICN",
                "description": "This course evaluates different types of eye trauma. Evaluation tools and treatment options for various eye trauma will be discussed.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Understanding the different types of eye trauma</li>\r\n    <li>Describe evaluation tools and assessment tools</li>\r\n    <li>List appropriate treatment options for each eye trauma injury</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "512CB365-6DC3-E911-814D-005056B14D10",
                        "course_category_name": "Injuries",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Procedures",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6527E533-CFC9-E511-82AF-005056B150D3",
                        "course_category_name": "Ear, Eye, Nose and Throat Disorders",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.8,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "7145BC2B-E417-F111-99AC-005056A7B953",
                "course_version": 1,
                "name": "Agricultural Illnesses & Injuries",
                "course_type": 1,
                "author_information": "Travis McCall PhD, APRN, CCP",
                "description": "Down on the Farm: Agricultural Illnesses and Injuries\u201d will describe illnesses and injuries among farm workers who may present to the emergency department. Content will include the incidence, diagnosis, and management of environmental exposures, vector-borne illnesses, toxicologic poisoning, and mechanical injuries that may occur among farm workers. Social determinants of health that may affect the care and health of farm workers will also be discussed.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe the epidemiology of illnesses and injuries among farm workers.</li>\r\n    <li>Understand the illnesses and injuries that may result from environmental, toxicologic, and mechanical exposures.</li>\r\n    <li>Discuss evidence-based care and treatment of patients who suffer farm-related illnesses or injuries.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "512CB365-6DC3-E911-814D-005056B14D10",
                        "course_category_name": "Injuries",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "38E8CB6F-E417-F111-99AC-005056A7B953",
                "course_version": 1,
                "name": "Mind the Gap: Toxic Alcohols",
                "course_type": 1,
                "author_information": "Nancy Denke, DNP, ACNP-BC, FNP-BC, FAEN, CEN, CCRN",
                "description": "When we consider alcohol toxicity as a diagnosis in the altered patient, the first thing that comes to mind is ethyl alcohol intoxication. However, it is important to understand that any alcohol, when consumed in sufficient quantity, can be toxic. Other \u201ctoxic alcohols\u201d we frequently overlook include methanol, ethylene glycol, propylene glycol, and isopropanol (isopropyl alcohol). In this presentation, we examine 3 different scenarios: an intentional overdose, an agitated patient who will not give you a history, and an inebriated individual with numerous medical and psychiatric histories that you have \u201cno clue what is going on with them.\u201d. And lastly, the simple \u201cvery drunk.\u201d. We will touch on propylene glycol, which is seen mainly in an inpatient setting with IV infusions that contain propylene glycol as an additive but must be \u201cconsidered\u201d in any patient. It is our job as providers to identify, treat, and manage the \u201crare\u201d toxic alcohols that have potentially life-threatening diagnoses. And that is not so easy!",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Identify the clinical and laboratory clues to recognizing toxic alcohol poisonings</li>\r\n    <li>Describe the goals of management and treatment in toxic alcohol poisoning</li>\r\n    <li>Examine the time-sensitive management actions for these poisonings</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1EE81567-9882-E211-B22E-0015171C1A75",
                        "course_category_name": "Substance Abuse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "54141F89-E417-F111-99AC-005056A7B953",
                "course_version": 1,
                "name": "Non-Fatal Strangulation",
                "course_type": 1,
                "author_information": "Heidi Gilbert MSN, RN, CEN, TCRN, SANE",
                "description": "All forms of intimate partner violence are detrimental to the overall wellness of our patients, some are even criminal. Strangulation is different, and much worse. Men who strangle are more likely to kill their victims, kill police, and perpetrate mass shootings. Strangulation is one of the few near fatal events that often leave little or no physical findings on patients presenting to the ED, urgent care, or clinic settings. What is the mechanism of injury and why is strangulation so deadly? What are the obvious and occult signs and symptoms the clinician should look for? What\u2019s the best (and worst) way to gather a patient history and document, and how does all of this relate to the medical exception to hearsay? \r\n \r\nThis is an emotional and knowledge packed 50-minute presentation. I am passionate about this topic having lost my sister in 2013 to domestic violence homicide. I\u2019ll share with you what I wish I\u2019d known and what I wish I\u2019d said. This presentation will give you the knowledge and tools to become a gladiator for victims of violence in your clinical setting.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe the mechanism of injury in strangulation</li>\r\n    <li>Summarize the anoxic progression experienced during strangulation</li>\r\n    <li>Identify trauma-informed interviewing techniques and why this is important to victims of trauma.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57DADFC8-E203-E911-A43F-005056B13721",
                        "course_category_name": "Sexual Abuse & Assault",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "51FB57AE-C98C-EB11-80DF-005056B134EC",
                        "course_category_name": "Intimate Partner Violence",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "512CB365-6DC3-E911-814D-005056B14D10",
                        "course_category_name": "Injuries",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "2E45119E-E417-F111-99AC-005056A7B953",
                "course_version": 1,
                "name": "Not-so-Sweet Hidden Threat of DKA",
                "course_type": 1,
                "author_information": "Rachel Helms, DNP, APRN, AGACNP-BC, FNP-BC, ENP-C \r\nJoni Winter, DNP, CRNP, FNP-BC, AGACNP-BC, ENP-C, CVNP-BC",
                "description": "Euglycemic diabetic ketoacidosis (EDKA) is an uncommon but life-threatening process identified in patients with type 1 and 2 diabetes. The condition is characterized by normoglycemia in the setting of an anion gap, metabolic ketoacidosis.  There are several risk factors for developing EDKA; however, increased risks are linked to SGLT2 inhibitor use, type 1 diabetes, and bariatric surgeries secondary to prolonged perioperative fasting.\r\n \r\nEDKA occurs as serum insulin levels decrease and excess counter regulatory hormones develop due to a carbohydrate deficit. The resulting increased glucagon/insulin ratio causes lipolysis, increased free fatty acids, and ketoacidosis.\r\n \r\nUnfortunately, the normal glucose level causes the diagnosis of EDKA to be delayed in almost 50% of patients. Therefore, EDKA should be included in the differential list for all patients with the risk factors and symptoms mentioned above.\r\n \r\nIn order to increase awareness and understanding of EDKA, this presentation will utilize a case study format to illustrate a patient who presents to the emergency department and is ultimately diagnosed with often-missed diagnosis.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Recognize risk factors associated with euglycemic diabetic ketoacidosis (EDKA).</li>\r\n    <li>Discuss the pathophysiology of EDKA.</li>\r\n    <li>Identify the typical presenting symptoms and diagnostic criteria for EDKA.</li>\r\n    <li>Develop an appropriate plan of care for a patient diagnosed with EDKA.       </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8833B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Endocrine Disorders",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "6B692541-E417-F111-99AC-005056A7B953",
                "course_version": 1,
                "name": "BRASH Syndrome Identification & Management",
                "course_type": 1,
                "author_information": "Jacob Miller, DNP, MBA, ACNP, ENP-C, CNS, NRP",
                "description": "This presentation will present a patient scenario with a constellation of bradycardia, renal failure, AV nodal blockade, shock, and hyperkalemia (BRASH Syndrome) and highlight considerations in identifying and managing these patients in the emergency setting. Pharmacotherapeutic content will involve the role of pharmacologic agents as a contributing mechanism (i.e., AV nodal blocking agents) in addition to the pharmacotherapeutic management of BRASH Syndrome.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe the pathophysiology of BRASH Syndrome and articulate the synergy between each of its components</li>\r\n    <li>Formulate a treatment plan to rapidly intervene to prevent morbidity and mortality in a patient with BRASH Syndrome</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6FCCD559-0EBF-E211-97A9-001517135213",
                        "course_category_name": "Cardiac Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "27BB2B08-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Patient Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "BA92725B-E417-F111-99AC-005056A7B953",
                "course_version": 1,
                "name": "Fundamentals of CXR",
                "course_type": 1,
                "author_information": "Ronald Ray, DNAP, CRNA, FNP-C, ENP-C",
                "description": "This course provides an introduction to the interpretation of chest radiographs (CXR). Learners will be guided through a systematic approach to reading CXR films to ensure consistent and accurate evaluation. The course reviews normal thoracic anatomy as visualized on chest radiographs, helping participants recognize expected structures and variations. It also introduces common disease patterns seen on CXR, enabling learners to identify and describe radiographic findings associated with a range of pulmonary and thoracic conditions.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe a systematic approach to reading CXR films.\r\n    </li>\r\n    <li>Describe normal anatomy as viewed on a CXR film.</li>\r\n    <li>Describe various disease patterns as viewed on CXR films.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.2,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "4C00C9BD-E417-F111-99AC-005056A7B953",
                "course_version": 1,
                "name": "Peripheral Vascular Injuries",
                "course_type": 1,
                "author_information": "Kelley Scott, DNP, ENP-C, FNP-BC",
                "description": "Peripheral vascular injuries can be devastating, threatening to life and or limb. These injuries may occur as a result of an accident, from a motor vehicle, a fall, an athletic injury, or from an assault. Individuals with blunt and penetrating trauma are at risk for peripheral vascular injury. Peripheral vascular injuries can present a challenge for healthcare providers. An injury to a vital blood vessel can be subtle and difficult to identify. Delay of diagnosis may lead to complicating hemorrhage, aneurysm formation, arteriovenous fistulization, and gangrene.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Define Peripheral Vascular Injury</li>\r\n    <li>Assessment Findings/Presentation</li>\r\n    <li>Diagnostic Evaluation</li>\r\n    <li>Criteria for Scoring Peripheral Vascular Injuries</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93823AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Vascular Disorders",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.9,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "3D506354-1717-F111-99A8-005056A7C0C7",
                "course_version": 1,
                "name": "Advanced Airway Management in Emergency Care Settings",
                "course_type": 1,
                "author_information": "Michael Gooch, DNP, APRN, ACNP-BC, FNP-BC, FAANP, FAEN",
                "description": "Advanced airway management is the most common life saving intervention performed in emergency care settings. Unfortunately, this intervention does not come without risks. This presentation will review current recommended practices to improve success and reduce complications, especially hypoxia and hypotension. Airway assessment, preparation and planning, medication selection, and a brief overview of ventilator management will be included. At the conclusion of this presentation, emergency nurse practitioners will be better prepared to manage airways, reduce complications, and improve outcomes.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Explain the priorities of airway management.\r\n    </li>\r\n    <li>Recall pharmacotherapeutic properties of medications used with advanced airway management.\r\n    </li>\r\n    <li>Plan appropriate interventions for patients with impaired airway and ventilations.\r\n    </li>\r\n    <li>Evaluate the effectiveness of interventions for patients with impaired airway and ventilation.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFFFFFFF-FFFF-FFFF-FFFF-000000001090",
                        "course_category_name": "Airway Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "78FF3F4D-5017-F111-99A8-005056A7C0C7",
                "course_version": 1,
                "name": "Acute Alcohol Withdrawal in the ED: Navigating the Storm",
                "course_type": 1,
                "author_information": "Sharon Rainer, PhD, APRN, ENP-C, FNP-BC, PMHNP-BC",
                "description": "Acute alcohol withdrawal is a potentially life-threatening condition that requires prompt recognition and management to prevent severe complications such as seizures, delirium tremens (DTs), and cardiovascular instability. Effective management of acute alcohol withdrawal in the ED involves prompt identification, appropriate use of pharmacological and supportive treatments, and careful monitoring. Early intervention and proper follow-up are crucial for reducing complications and improving patient outcomes.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Prepare emergency clinicians to accurately identify and assess the severity of acute alcohol withdrawal using clinical tools and symptom evaluation to ensure timely and effective intervention.\r\n    </li>\r\n    <li>Provide a detailed overview of current best practices for managing acute alcohol withdrawal, including pharmacological therapies and supportive care, to mitigate withdrawal symptoms and prevent complications.\r\n    </li>\r\n    <li>Develop strategies for effective patient disposition, including risk stratification and planning for appropriate next level of care</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1EE81567-9882-E211-B22E-0015171C1A75",
                        "course_category_name": "Substance Abuse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "3EB86657-E917-F111-99A8-005056A7C0C7",
                "course_version": 1,
                "name": "Trauma in the ED",
                "course_type": 1,
                "author_information": "Tiffany Andrews, MS, ACNP-BC, ENP-C",
                "description": "Accidental and traumatic injuries remain one of the leading causes of death worldwide, accounting for 5.8 million deaths annually and a large percentage of ED evaluations. Increasing disease severity creates an environment that makes patient care difficult. Throughout this presentation, we will discuss the initial evaluation and management of trauma patients in the ED and how to identify potential traumatic injuries based on mechanism of injury.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe mechanism of injury and triage of trauma patients in the Emergency Department</li>\r\n    <li>Describe the initial evaluation and management of the patient with traumatic injuries in the Emergency Department</li>\r\n    <li>Identify the different types of trauma seen in the Emergency Department</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5636B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Trauma Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "512CB365-6DC3-E911-814D-005056B14D10",
                        "course_category_name": "Injuries",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.2,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "FC393F6B-E917-F111-99A8-005056A7C0C7",
                "course_version": 1,
                "name": "Top 5 Finger Complaints in Emergency Care",
                "course_type": 1,
                "author_information": "Michael Gooch, DNP, APRN, CCP, ACNP-BC, FNP-BC, ENP-C",
                "description": "Using a case-based approach, this presentation will review five common finger complaints encountered in emergency care settings: Flexor Tenosynovitis, Felon, Paronychia, Subungal Hematoma, and Herpetic Whitlow. Some of these are minor and some can have significant problems if not managed appropriately. Assessment findings and management options will be reviewed during this presentation.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Recall key aspects of performing a hand and finger assessment.</li>\r\n    <li>Identify five common finger complaints encountered in emergency care settings.</li>\r\n    <li>Recall the classic presentations of select finger emergencies.</li>\r\n    <li>Describe pharmacologic options for managing select finger emergencies</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "27BB2B08-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Patient Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.6,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "2C348AA3-7816-F111-99A7-005056A7C0C7",
                "course_version": 1,
                "name": "Baby Trauma Drama: Initial Evaluation and Management of Minor Head Trauma in Infants & Children",
                "course_type": 1,
                "author_information": "Speaker: Ashton Glover, DNP, FNP-C, ENP-C, SANE-A and Amanda Hitt, MSN, FNP-BC",
                "description": "This course reviews the typical clinical findings associated with minor head trauma in infants and young children and outlines a systematic approach to initial evaluation in the emergency department. Learners will develop practical skills in risk stratification and decision-making by applying the PECARN head trauma algorithm to infant cases, with an emphasis on identifying children at low risk for clinically significant traumatic brain injury while minimizing unnecessary imaging.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Discuss common findings associated with minor head trauma in infants and young children\r\n    </li>\r\n    <li> Describe the initial evaluation of infants and young children presenting to the emergency department with minor head trauma\r\n    </li>\r\n    <li>Apply the PECARN algorithm to a case of minor, infant head trauma</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "8C2AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E5A9019D-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "512CB365-6DC3-E911-814D-005056B14D10",
                        "course_category_name": "Injuries",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9106255A-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Pediatric - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "CC317627-4817-F111-99A8-005056A7C0C7",
                "course_version": 1,
                "name": "Business Start Up Basics",
                "course_type": 1,
                "author_information": "Lamon Norton, NP",
                "description": "Delivery of the imperative start up basics for the clinician who is an aspiring business owner, including legal, financial, and market considerations.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li> Identify key tasks to start a business </li>\r\n    <li>Review fiscal elements necessary to a proforma (business plan).    </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D4B948D5-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB3023AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Knowledge Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "05EA179B-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Professional Practice - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4C5C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Professional Practice Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C01FDB4F-F53E-E711-B09D-005056B10493",
                        "course_category_name": "Leadership & Workforce Development",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "DA6AFC27-E917-F111-99A8-005056A7C0C7",
                "course_version": 1,
                "name": "Screening for Delirium in Patients with Serious Mental Illness & Dementia",
                "course_type": 1,
                "author_information": "Sharon Rainer, PhD, APRN, ENP-C, FNP-BC, PMHNP-BC",
                "description": "The aim of this presentation is to provide a thorough understanding of how to effectively screen for delirium in patients with serious mental illness (SMI) or dementia in the emergency department (ED). Patients with SMI, such as schizophrenia or bipolar disorder, are at increased risk for delirium, which can complicate their clinical presentation and management. Early detection is crucial for preventing adverse outcomes and ensuring appropriate care. The importance of addressing underlying causes, stabilizing the patient, and employing supportive measures will be discussed. In addition, pharmacologic and non-pharmacologic interventions while considering the impact of these treatments on both delirium and pre-existing psychiatric conditions will be emphasized.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Prepare emergency clinicians to distinguish delirium from psychosis and dementia, focusing on identifying key clinical features and using appropriate screening tools to ensure accurate diagnosis.</li>\r\n    <li>Provide a practical guide for implementing screening protocols for delirium in patients with SMI and dementia, including the use of validated tools.</li>\r\n    <li>Outline strategies for managing patients diagnosed with delirium, including addressing underlying causes, stabilizing symptoms, and coordinating care with multidisciplinary teams.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ED7E45AB-9782-E211-B22E-0015171C1A75",
                        "course_category_name": "Psychiatric Disorders",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "0298E844-E917-F111-99A8-005056A7C0C7",
                "course_version": 1,
                "name": "That Bites: Snakes, Stings, and other Things!",
                "course_type": 1,
                "author_information": "Ashton Glover, DNP, FNP-C, ENP-C, SANE-A",
                "description": "In this presentation, I discuss the evaluation and management of animal bites, focusing on dog bites and snake bites. I cover the initial assessment, wound care, post-exposure prophylaxis, and criteria for surgical consultation. Viewers are instructed on important considerations such as rabies prophylaxis and antibiotic prophylaxis. Action requested includes understanding the guidelines for managing different types of animal bites.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Discuss the evaluation of a patient with an animal bite or sting.</li>\r\n    <li>Describe the presentation of a patient exhibiting venom toxicity</li>\r\n    <li>Review management strategies for animal bites and stings</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "27BB2B08-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Patient Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "512CB365-6DC3-E911-814D-005056B14D10",
                        "course_category_name": "Injuries",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.4,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "A97370AA-4617-F111-99A8-005056A7C0C7",
                "course_version": 1,
                "name": "Don't Ask, Don't Tell! Pregnancy-Related Hypertensive Emergencies that are Easy to Miss",
                "course_type": 1,
                "author_information": "Toni Dobson, MSN, ARPN, FNP-C, ENP-C",
                "description": "In this interactive, case-based presentation, we will cover a variety of ED presentations of pregnancy-related HTN, including pregnant and postpartum examples and some that were near-misses. Cases will be linked to the 2024 ACOG guidelines published to help non-obstetric providers manage pregnancy-related emergencies. We will discuss how to diagnose gestational hypertension, Pre-eclampsia, and Pre-eclampsia with severe features. Then, we will decide together how to treat each patient and determine who gets admitted and who goes home.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Develop a method to consistently identify this at-risk population of women.\r\n    </li>\r\n    <li>Define mild and severe range blood pressure and identify what requires urgent management.\r\n    </li>\r\n    <li>Diagnose gestational hypertension, pre-eclampsia, and pre-eclampsia with severe features.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "71623ACF-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - OB Emergencies Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93823AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Vascular Disorders",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A3767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - OB Emergencies Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7A1F6972-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - OB Emergencies - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "975A148E-A6FF-E611-A64B-005056B1522B",
                        "course_category_name": "Obstetric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "26EF2AA5-22FE-E611-A7FF-005056B16BE3",
                        "course_category_name": "Obstetric Disorders",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            }
        ]
    }
];